module.exports = {
  CHECK_ITEM_TOO_LONG_ERROR: {
    name: 'check-item-too-long-error',
    description:
      'toggle desenvolvido no Ciclo 26, quando ativado habilita o fluxo de verificar se o erro de ITEM TOO LONG existe na resposta do AddMultiElement'
  },
  CARD_MONTH_YEAR_SELECT_FIELD: {
    name: 'card-month-year-select-field',
    description:
      'toggle desenvolvido no Ciclo 5 pelo time Phantom, quando ativado habilita o novo componente de combo do cartão.'
  },
  AMADEUS_WITH_MASTER_PRICER: {
    name: 'amadeus-with-master-pricer',
    description:
      'toggle desenvolvido no Ciclo 6 pelo time Phantom, quando ativado habilita a busca de voos pelo servico do Amadeus MPricer'
  },
  FLIGHT_HISTORY_SERVICE: {
    name: 'flight-history-service',
    description:
      'toggle desenvolvido no Ciclo 10 pelo time Phantom, quando ativado habilita o uso do servico de busca de voos recentes '
  },
  HOME_VALIDATION_SERVICE: {
    name: 'home-validation-service',
    description:
      'toggle desenvolvido no Ciclo 11 pelo time Phantom, quando ativado habilita o uso do servico de validação na home'
  },
  HOME_SEARCH_DEEPLINK: {
    name: 'home-search-deeplink',
    description:
      'toggle desenvolvido no Ciclo 11 pelo time Phantom, quando ativado habilita a criação da url do deep link'
  },
  PORTAL_LOGGER: {
    name: 'portal-logger',
    description:
      'toggle desenvolvido no Ciclo 40 pelo time Mustang, quando ativado habilita a API que permite a integração entre o Portal e o Graylog'
  },
  CALLCENTER_MODE: {
    name: 'callcenter-mode',
    description:
      'toggle desenvolvido no Ciclo 17 pelo time Phantom, quando ativado features implementadas para contemplar o fluxo do callcenter'
  },
  ELAPSED_FLIGHT_TIME: {
    name: 'elapsed-flight-time',
    description:
      'toggle desenvolvido no Ciclo 19 pelo time Phantom, quando ativado habilita a alteração do layout da grid de seleção de vôo, exibindo tempo total de vôo'
  },
  DETAILS_MODAL: {
    name: 'details-modal',
    description:
      'toggle desenvolvido no Ciclo 19 pelo time Phantom, quando ativado habilita a alteração do layout da modal de detalhes do voo'
  },
  ADYEN_CARD_ENCRYPTED: {
    name: 'adyen-card-encrypted',
    description:
      'toggle desenvolvido no Ciclo 21 pelo time Phantom, quando ativado habilita a encriptação dos dados de cartão de crédito'
  },
  REFUND_RULES_DETAIL: {
    name: 'refund-rules-detail',
    description:
      'toggle desenvolvido no Ciclo 23 pelo time Phantom, quando ativado habilita os detalhes de taxa de cancelamento na tela de resumo da seleção de voo'
  },
  FLIGHT_RESUME_CANCELLATION_MESSAGE: {
    name: 'flight-resume-cancellation-message',
    description:
      'toggle desenvolvido no Ciclo 23 pelo time Phantom, quando ativado habilita a exibição da mensagem de orientação para cancelamento '
  },
  SHOW_MODAL_SELECTION_FLIGHTS: {
    name: 'show-modal-selection-flights',
    description:
      'toggle desenvolvido no Ciclo 25 pelo time Phantom, quando ativado exibe o modal na seleção de voos'
  },
  CURRENCY_CONVERTER: {
    name: 'currency-converter',
    description:
      'toggle desenvolvido no Ciclo 25 pelo time Phantom, quando ativado retorna o currency converter no get refund rules'
  },
  SORT_FLIGHTS_BY_FLIGHT_GROUP: {
    name: 'sort-flights-by-flight-group',
    description:
      'toggle desenvolvido na Sprint 2 pelo time da Avanade. Quando Ativado, ordena os voos de ida e volta pela quantidade de paradas'
  },
  FILTER_FLIGHTS_AFTER_SEARCH: {
    name: 'filter-flights-after-search',
    description:
      'toggle desenvolvido na Sprint 3 pelo time da Avanade. Quando Ativado, filtra os voos de ida e volta por bagagem, qtd de voos, companhias areas'
  },
  BUSINESS_WITH_MAJOR_CABIN: {
    name: 'business-with-major-cabin',
    description:
      'toggle desenvolvido na Sprint 3 pelo time da Avanade. Quando ativado, informar qual o tipo de cabine para cada trecho operado'
  },
  AWARD_POINTS_PLUS_MONEY: {
    name: 'award-points-plus-money',
    description:
      'Se a feature Toggle estiver habilitada então o getPoints irá retornar os pontos e o range para tarifas AWARD'
  },
  PUBLIC_POINTS_PLUS_MONEY: {
    name: 'public-points-plus-money',
    description:
      'Se a feature Toggle estiver habilitada então o getPoints irá retornar os pontos e o range para tarifas PUBLIC'
  }
};



// WEBPACK FOOTER //
// ./src/const/Features.js